var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Route, Redirect } from "react-router";
import { NestedRoute } from "@irati/utils/history/routing";
import NotFound from "../NotFound";
import Maintenance from "../Maintenance";
import Welcome from "./welcome";
import Ghost from "../../containers/Ghost";
var platform = /** @class */ (function (_super) {
    __extends(platform, _super);
    function platform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    platform.prototype.render = function () {
        var path = this.props.path;
        return (React.createElement(Route, { path: path },
            React.createElement(React.Fragment, null,
                React.createElement(Route, { path: "/welcome", component: Welcome }),
                React.createElement(Route, { noauth: true, path: "/internal/ghost", component: Ghost }),
                React.createElement(NestedRoute, { noauth: true, match: path, path: "maintenance", component: Maintenance, title: "Perkbox under maintenance" }),
                React.createElement(Route, { path: "NotFound", component: NotFound }),
                React.createElement(Route, { exact: true, path: "/signup", render: function () { return React.createElement(Redirect, { to: "/welcome/signup" }); } }))));
    };
    return platform;
}(Component));
export default platform;
